import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatOptionModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectChange, MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDivider} from "@angular/material/divider";
import {NgForOf, NgIf} from "@angular/common";
import {TranslocoPipe} from "@ngneat/transloco";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {BasicInfoFieldNames, CalitatePersoana} from "../basic.patient.info.types";
import {SignatureComponent} from "../../signature/signature.component";
import {BasicWizzard} from "../../base-behaviour/wizzard";
import {DocummentsService} from "../../documents.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DocummentAuditStatus, DocUserField} from "../../document-types";
import {getValueOfFieldWithName} from "../../base-behaviour/base.behaviour.doc.types";
import {GenderType} from "../../../../core/types/smm/smm-person.types";
import {SMMValidators} from "../../../../core/validators";
import {FuseAlertComponent} from "../../../../../@fuse/components/alert";

@Component({
    selector     : 'basic-patient-info',
    templateUrl  : './basic-patient-info-wizzard.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone   : true,
    imports: [MatIconModule, FormsModule, ReactiveFormsModule, MatStepperModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatOptionModule, MatButtonModule, MatCheckboxModule, MatRadioModule, MatDivider, NgIf, TranslocoPipe, MatDatepicker, MatDatepickerInput, MatDatepickerToggle, SignatureComponent, FuseAlertComponent, NgForOf],
})
export class BasicPatientInfoWizzard extends BasicWizzard implements OnInit, OnDestroy
{
    protected readonly CalitatePersoana = CalitatePersoana;
    basicPatientInfo: UntypedFormGroup;
    protected legalPersInfReq: boolean = false;
    private patched: boolean = false;

    constructor(
        private readonly _formBuilder: UntypedFormBuilder,
        _docsService: DocummentsService,
        route: ActivatedRoute,
        router: Router,
        cdrf: ChangeDetectorRef,

    )
    {
        super(_docsService, route, router, cdrf);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------


    /**
     * On init
     */
    ngOnInit(): void
    {
        // Vertical stepper form
        this.basicPatientInfo = this._formBuilder.group({
            step1: this._formBuilder.group({
                basic_tipPersoana : ['', Validators.required],
            }),
            step2: this._formBuilder.group({
                basic_prenumePacient     : ['', Validators.required],
                basic_numePacient        : ['', Validators.required],
                basic_addrPacient        : ['', Validators.required],
                basic_dateOfBirthPacient : [null],
                basic_cnpPacient         : ['', SMMValidators.cnpValidator()],
                basic_prenumeLegalPers   : [''],
                basic_numeLegalPers      : [''],
                basic_addrLegalPers      : [''],
                basic_sex                : [''],
                basic_phone              : ['',[Validators.required, SMMValidators.phoneNumber()]],
                basic_email              : ['', Validators.email],

            })
        });
        this.init();
    }

    ngOnDestroy(): void {
        this.destroy()
    }

    enableLegalPers($event: MatSelectChange) {
        this.legalPersInfReq = $event.value != CalitatePersoana.PACIENT;
        if(this.legalPersInfReq){
            this.basicPatientInfo.get("step2").get('basic_prenumeLegalPers').setValidators([Validators.required]);
            this.basicPatientInfo.get("step2").get('basic_numeLegalPers').setValidators([Validators.required]);
            this.basicPatientInfo.get("step2").get('basic_addrLegalPers').setValidators([Validators.required]);
        }else{
            this.basicPatientInfo.get("step2").get('basic_prenumeLegalPers').clearValidators();
            this.basicPatientInfo.get("step2").get('basic_prenumeLegalPers').reset();
            this.basicPatientInfo.get("step2").get('basic_numeLegalPers').clearValidators();
            this.basicPatientInfo.get("step2").get('basic_numeLegalPers').reset()
            this.basicPatientInfo.get("step2").get('basic_addrLegalPers').clearValidators();
            this.basicPatientInfo.get("step2").get('basic_addrLegalPers').reset();
        }
        this.syncField(this.basicPatientInfo,'step1', 'basic_tipPersoana', 'basic_tipPersoana');
        this.cdrf.markForCheck();
    }

    CNPChanged() {
        if(this.basicPatientInfo.get("step2").get('basic_cnpPacient').valid && !this.basicPatientInfo.get("step2").get('basic_cnpPacient').pristine){
            //we extract birthday from CNP
            // const CNP:string = this.basicPatientInfo.get("step2").get('basic_cnpPacient').value;
            // const after2000 =  +CNP.charAt(0) >= 5;
            // const extractedYear = CNP.substring(1,3);
            // const year = +((after2000 ? "20":"19") + extractedYear);
            // const month = +CNP.substring(3,5);
            // const day = +CNP.substring(5,7);
            //
            // const bDay = new Date(year, month-1, day);
            // this.basicPatientInfo.get("step2").get('basic_dateOfBirthPacient').setValue(bDay);
        }
    }

    birthDayChanged() {
        // const CNP:string = this.basicPatientInfo.get("step2").get('basic_cnpPacient').value;
        // const bDay:DateTime = this.basicPatientInfo.get("step2").get('basic_dateOfBirthPacient').value;
        // const cnpDate = CNP.substring(1,7);
        // const provDate = bDay.toFormat("yyMMdd");
        // if(cnpDate != provDate){
            //clear CNP field
            //this.basicPatientInfo.get("step2").get('basic_cnpPacient').setValue("");
        // }
        if(this.basicPatientInfo.get('step2').get(BasicInfoFieldNames.basic_dateOfBirthPacient).value){
        this.syncField(this.basicPatientInfo,'step2', 'basic_dateOfBirthPacient' , BasicInfoFieldNames.basic_dateOfBirthPacient);
            this.cdrf.markForCheck();
        }
    }

    public patchForm(userDocFields:DocUserField[]){
        if(!userDocFields || userDocFields.length == 0 || this.patched) {
            return;
        }

        const tipPers = getValueOfFieldWithName(userDocFields, BasicInfoFieldNames.basic_tipPersoana, this.documentID);
        if (tipPers) {
            this.basicPatientInfo.get('step1').get(BasicInfoFieldNames.basic_tipPersoana).setValue(tipPers);
        }

        Object.keys(BasicInfoFieldNames).forEach(key => {
            const val = getValueOfFieldWithName(userDocFields, key);
            if(val){
                this.basicPatientInfo.get('step2').get(key)?.setValue(val);
            }
        });

        this.patched = true;
        this.cdrf.markForCheck();
    }

    complete(){
        //basic info wizard is special, and has no corespondening flow in BE
        //therfore the status is saved ina this.syncField()
        const usrF: DocUserField = new DocUserField(this.documentID, BasicInfoFieldNames.basic_flowStatusField, DocummentAuditStatus.DONE);
        this._docsService.syncFields([usrF], this.documentID);
        this.navigateHome();
    }

    protected readonly BasicInfoFieldNames = BasicInfoFieldNames;
    protected readonly GenderType = GenderType;
}
